import React from 'react'

const ProfileErrorMessage = props => <div className="text-xs text-red-400 p-2" {...props} />

export default ProfileErrorMessage
